import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ErrorHandler, NgModule } from "@angular/core";
import { HttpClientModule, HttpClient, } from "@angular/common/http";
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular";
import { MyApp } from "./app.component";
import { SplashScreen } from "@ionic-native/splash-screen";
import { StatusBar } from "@ionic-native/status-bar";
import { Constants } from "../commons/constants";
import { SecurityConfiguration } from "../security/security.configuration";
import { IonicStorageModule } from "@ionic/storage";
import { SQLite } from "@ionic-native/sqlite";
import { DatabaseConfiguration } from "../database/database.configuration";
import { HomePageModule } from "../pages/home/home.module";
import { RequestMethodsService } from "../commons/request_methods";
import { Http } from "@angular/http/src/http";
import { AssetLandingPage } from '../pages/asset-landing/asset-landing';
import { LoginPageModule } from "../pages/login/login.module";
import { AssetLandingPageModule } from "../pages/asset-landing/asset-landing.module";
import { PDFService } from "../services/pdf.service";
import { File } from "@ionic-native/file";
import { FileOpener } from "@ionic-native/file-opener";
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpModule} from '@angular/http';
import { OAuthModule, OAuthService,UrlHelperService } from 'angular-oauth2-oidc';
import { DatePipe } from "@angular/common";
// export function HttpLoaderFactory(http: HttpClient) {
//   return new TranslateHttpLoader(http, 'assets/imgs/', '.json');
// }

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrowserModule,    
    BrowserAnimationsModule,
    HttpClientModule,
    OAuthModule.forRoot(),
    IonicStorageModule.forRoot(),
    IonicModule.forRoot(MyApp, {
      scrollAssist: false, //added these properties to stop erratic behavior of scrolling when clicked on disabled ion-input or last element of the form
      autoFocusAssist: false
    }),
    HomePageModule,
    LoginPageModule,
    AssetLandingPageModule,
    TranslateModule,   
    HttpModule,
  //   TranslateModule.forRoot({
  //     loader: {
  //         provide: TranslateLoader,
  //         useFactory: (HttpLoaderFactory),
  //         deps: [HttpClient]
  //     }
  // }),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [    
    OAuthService,    
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    Constants,
    SecurityConfiguration,
    SQLite,
    DatabaseConfiguration,
    RequestMethodsService,
    PDFService,
    File,
    FileOpener,
    UrlHelperService,
    DatePipe
  ],
})
export class AppModule {}




// WEBPACK FOOTER //
// ./src/app/app.module.ts